import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';
import { Breadcrumb } from '~/components/ui/layout/navigation/breadcrumb/Breadcrumb';
import { HeaderContainer } from '~/components/ui/layout/page/HeaderContainer';
import { PageContent } from '~/components/ui/layout/page/PageContent';
import { PageTagline } from '~/components/ui/layout/page/PageTagline';

// Todo: Check if page is needed
export const Route = createFileRoute('/_authLayout/company/$companyId')({
  component: () => <CompanyDetail />,
});

export const CompanyDetail = () => {
  return (
    <>
      <HeaderContainer>
        <Breadcrumb
          items={[
            { name: 'Dashboard', url: '/fund/overview' },
            { name: 'Portfolio Companies', url: '/company/list' },
            { name: 'Company Name TODO get from API' },
          ]}
        />
        <PageTagline message="Overview of all portfolio companies across funds" />
      </HeaderContainer>
      <PageContent>
        <div className="pt-3">Details</div>
      </PageContent>
    </>
  );
};
